import * as React from 'react';
import * as classNames from 'classnames';
import * as s from './LayoutContainer.sss';
export const LayoutContainer = ({ className, children }) => (React.createElement("div", { className: classNames(s.root, className) }, children));
